import { BaseWebService } from '../shared/services/base-web.service';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

@Injectable()
export class StatementsService {
    constructor(
        private _basewebservice: BaseWebService
    ) { }

    getStatementsList(limit: any, offset: any) {
        return this._basewebservice.request("v1/billing/statements/?limit=" + limit + "&offset=" + offset, "get")
            .map(res => res)
            .catch(this.handleError);
    }

    /**
     * Function to get statement pdf form from api.
     * @param  {any} id contains statement pdf id.
     */
    getStatementPdf(id: any) {
        return this._basewebservice.requestBlob("v1/billing/statements/" + id + "/download/", "get")
            .map(res => res)
            .catch(this.handleError);
    }

    handleError(error: Response | any) {
        return Observable.throw(error);
    }

}
